var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowShareRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6045 4.46536C11.6045 3.15695 13.1625 2.47582 14.1231 3.36419L22.2686 10.8988C22.9104 11.4926 22.9104 12.5073 22.2686 13.101L14.1231 20.6357C13.1626 21.524 11.6045 20.8429 11.6045 19.5345V16.2548C7.77593 16.3059 5.81629 16.7572 4.64967 17.4456C3.50838 18.119 3.03741 19.061 2.29875 20.5384L2.27531 20.5853C2.11975 20.8964 1.7707 21.0598 1.43217 20.9799C1.09365 20.8999 0.854492 20.5977 0.854492 20.2499C0.854492 16.0687 1.385 12.923 3.117 10.8242C4.84697 8.72787 7.617 7.85297 11.6045 7.75861V4.46536ZM13.1045 4.46536V7.99995C13.1045 8.70129 12.5321 9.24315 11.8623 9.2538C7.89041 9.31697 5.61195 10.1576 4.27393 11.779C3.25492 13.0138 2.68972 14.804 2.46712 17.348C2.84618 16.9032 3.30269 16.4987 3.88742 16.1537C5.44418 15.2351 7.81215 14.7868 11.843 14.7521C11.8429 14.7521 11.843 14.7521 11.843 14.7521C12.53 14.7462 13.1045 15.3014 13.1045 15.9999V19.5345L21.25 12L13.1045 4.46536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShareRight);
export default __webpack_public_path__ + "static/media/arrow-share-right.fe468378ec9f1274ae30f89c694039c6.svg";
export { ForwardRef as ReactComponent };